import {
  type PaginatedDeployment,
  type PaginatedDeploymentWithRoles,
  type PaginatedTransformedDeploymentWithRoles,
} from "@/api/resources/deployments/types";
import { sortArray } from "@/utils/sort";

import type { CurrentUserProfile, CurrentUserProfileUserToWorkspace } from "@/api/resources/users/types";
import type { CustomerWorkspaceAnalytics } from "@/api/resources/workspaces/types";

interface SelectorFilteredDeploymentsProps {
  currentWorkspaceId?: string;
  deployments: PaginatedDeployment[];
  customerWorkspaces: CustomerWorkspaceAnalytics[];
}
export const selectorFilteredDeployments = ({
  currentWorkspaceId,
  deployments,
  customerWorkspaces,
}: SelectorFilteredDeploymentsProps) => {
  const customerWorkspaceIds = customerWorkspaces.map((workspace) => workspace.id);

  const _deployments = deployments.filter((deployment) => deployment.workspace_id === currentWorkspaceId);
  const _customerDeployments = deployments.filter((deployment) =>
    customerWorkspaceIds.includes(deployment.workspace_id),
  );

  return sortArray([..._deployments, ..._customerDeployments]).asc("name");
};

interface SelectorCurrentDeploymentsProps {
  currentWorkspaceId?: string;
  deployments: PaginatedDeployment[];
}
export const selectorCurrentDeployments = ({ currentWorkspaceId, deployments }: SelectorCurrentDeploymentsProps) => {
  return deployments.filter(
    ({ workspace_id, deleted_at }) => workspace_id === currentWorkspaceId && deleted_at === null,
  );
};

interface SelectorDeploymentsWithRolesForUser {
  currentWorkspaceId?: string;
  currentWorkspaceRole?: CurrentUserProfileUserToWorkspace | null;
  currentUser?: CurrentUserProfile | null;
  deployments: PaginatedDeploymentWithRoles[];
}
export const selectorDeploymentsWithRolesForUser = ({
  currentUser,
  deployments,
}: SelectorDeploymentsWithRolesForUser): PaginatedTransformedDeploymentWithRoles[] => {
  return (
    deployments
      // find and assign the role for the current user and deployment
      .map((deployment) => ({
        ...deployment,
        current_deployment_role: deployment.users_to_deployments.find((u2d) => u2d.user_id === currentUser?.id),
      }))
  );
};
